import getDayName, { getMonthName, padTo2Digits } from "utils/modifyDate";
import styles from "./GroupDate.module.scss";

const GroupDate = ({ date }) => {
  return (
    <h2 className={styles.title}>{`${getDayName(date, "long")}, ${padTo2Digits(
      date.getDate()
    )} ${getMonthName(date)}`}</h2>
  );
};

export default GroupDate;
